import axios from 'axios';
import {checkErrors} from './errors';

export const LOADSTORES_REQUESTED = 'stores/LOADSTORES_REQUESTED';
export const LOADSTORES_FINISHED = 'stores/LOADSTORES_FINISHED';
export const SETSTORES = 'stores/SETSTORES';

export const ADDSTORE_REQUESTED = 'stores/ADDSTORE_REQUESTED';
export const ADDSTORE_FINISHED = 'stores/ADDSTORE_FINISHED';

export const EDITSTORE_REQUESTED = 'stores/EDITSTORE_REQUESTED';
export const EDITSTORE_FINISHED = 'stores/EDITSTORE_FINISHED';

export const REMOVESTORE_REQUESTED = 'stores/REMOVESTORE_REQUESTED';
export const REMOVESTORE = 'stores/REMOVESTORE';
export const REMOVESTORE_FINISHED = 'stores/REMOVESTORE_FINISHED';

export const LOADSTOREASSIGNMENTS_REQUESTED = 'stores/LOADSTOREASSIGNMENTS_REQUESTED';
export const LOADSTOREASSIGNMENTS_FINISHED = 'stores/LOADSTOREASSIGNMENTS_FINISHED';
export const SETSTOREASSIGNMENTS = 'stores/SETSTOREASSIGNMENTS';

export const ADDSTOREASSIGNMENT_REQUESTED = 'floorplans/ADDSTOREASSIGNMENT_REQUESTED';
export const ADDSTOREASSIGNMENT_FINISHED = 'floorplans/ADDSTOREASSIGNMENT_FINISHED';

export const REMOVESTOREASSIGNMENT_REQUESTED = 'floorplans/REMOVESTOREASSIGNMENT_REQUESTED';
export const REMOVESTOREASSIGNMENT_FINISHED = 'floorplans/REMOVESTOREASSIGNMENT_FINISHED';

export const LOADSTORE_REQUESTED = 'stores/LOADSTORE_REQUESTED';
export const LOADSTORE_FINISHED = 'stores/LOADSTORE_FINISHED';

const initialState = {
  stores: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingStores: false,
  isAddingStore: false,
  isEditingStore: false,
  isRemovingStore: false,
  storeassignments: [],
  isLoadingStoreAssignments: false,
  isAddingStoreAssignment: false,
  isRemovingStoreAssignment: false,
  isLoadingStore: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADSTORES_REQUESTED:
    return {
      ...state,
      isLoadingStores: true
    };

  case LOADSTORES_FINISHED:
    return {
      ...state,
      isLoadingStores: false
    };

  case SETSTORES:
    
    return {
      ...state,
      stores: action.stores
    };

  case ADDSTORE_REQUESTED:
    return {
      ...state,
      isAddingStore: true
    };

  case ADDSTORE_FINISHED:
    return {
      ...state,
      isAddingStore: false
    };
  
  case EDITSTORE_REQUESTED:
    return {
      ...state,
      isEditingStore: true
    };

  case EDITSTORE_FINISHED:
    return {
      ...state,
      isEditingStore: false
    };

  case REMOVESTORE:
    return {
      ...state,
      stores: action.stores
    };

  case REMOVESTORE_REQUESTED:
    return {
      ...state,
      isRemovingStore: true,
    };

  case REMOVESTORE_FINISHED:
    return {
      ...state,
      isRemovingStore: false
    };

  case LOADSTOREASSIGNMENTS_REQUESTED:
    return {
      ...state,
      isLoadingStoreAssignments: true
    };

  case LOADSTOREASSIGNMENTS_FINISHED:
    return {
      ...state,
      isLoadingStoreAssignments: false
    };

  case SETSTOREASSIGNMENTS:
    
    return {
      ...state,
      storeassignments: action.storeassignments
    };
  
  case ADDSTOREASSIGNMENT_REQUESTED:
    return {
      ...state,
      isAddingStoreAssignment: true
    };

  case ADDSTOREASSIGNMENT_FINISHED:
    return {
      ...state,
      isAddingStoreAssignment: false
    };

  case REMOVESTOREASSIGNMENT_REQUESTED:
    return {
      ...state,
      isRemovingStoreAssignment: true
    };

  case REMOVESTOREASSIGNMENT_FINISHED:
    return {
      ...state,
      isRemovingStoreAssignment: false
    };

  case LOADSTORE_REQUESTED:
    return {
      ...state,
      isLoadingStore: true
    };

  case LOADSTORE_FINISHED:
    return {
      ...state,
      isLoadingStore: false
    };

  default:
    return state;
  }
};


export const loadStores = () => {
  return (dispatch, getState) => {

    const storesState = getState().stores;

    dispatch({
      type: LOADSTORES_REQUESTED
    });

    axios.get(`${window.endpoint}/stores?limit=${storesState.limit}&skip=${storesState.skip}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      
      dispatch({
        type: SETSTORES,
        stores: response.data.stores
      });
      
      dispatch({
        type: LOADSTORES_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addStore = (data, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDSTORE_REQUESTED
    });

    axios.post(`${window.endpoint}/stores`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: ADDSTORE_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editStore = (id, data, cb) => {
  return (dispatch, getState) => {
    

    dispatch({
      type: EDITSTORE_REQUESTED
    });

    axios.post(`${window.endpoint}/stores/${id}`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: EDITSTORE_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeStore = (id, cb) => {
  return (dispatch, getState) => {

    const storesState = getState().stores;

    dispatch({
      type: REMOVESTORE_REQUESTED
    });

    axios.delete(`${window.endpoint}/stores/${id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVESTORE,
        stores: storesState.stores.filter((store) => store.id !== id)
      });
      
      dispatch({
        type: REMOVESTORE_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadStore = (store_id, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADSTORE_REQUESTED
    });

    axios.get(`${window.endpoint}/stores/${store_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: LOADSTORE_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadStoreAssignments = (cb) => {
  return (dispatch, getState) => {

    const storesState = getState().stores;
    
    dispatch({
      type: LOADSTOREASSIGNMENTS_REQUESTED
    });

    axios.get(`${window.endpoint}/storeassignments?limit=${storesState.limit}&skip=${storesState.skip}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      dispatch({
        type: SETSTOREASSIGNMENTS,
        storeassignments: response.data.storeassignments
      });
      
      dispatch({
        type: LOADSTOREASSIGNMENTS_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addStoreAssignment = ({floor_plan_id, store_id, room_name}, cb) => {
  return dispatch => {
    dispatch({
      type: ADDSTOREASSIGNMENT_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ floor_plan_id, store_id, room_name, is_active: 1 }));

    axios.post(`${window.endpoint}/storeassignments`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      // GET the new add Store Assignment, get the response, insert the object as the callback
      if (cb instanceof Function) { cb(); }

      dispatch({
        type: ADDSTOREASSIGNMENT_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeStoreAssignment = (mil_id, cb) => {
  return dispatch => {
    dispatch({
      type: REMOVESTOREASSIGNMENT_REQUESTED
    });

    axios.delete(`${window.endpoint}/storeassignments/${mil_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }

      dispatch({
        type: REMOVESTOREASSIGNMENT_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};


// WEBPACK FOOTER //
// ./src/reducers/stores.js